import {logger} from '@vio/core/src/utils/logging/logger'

export const getApiUrl = () => {
  const url = process.env.NEXT_PUBLIC_AGENT_API_URL
  if (!url) {
    logger.error('NEXT_PUBLIC_AGENT_API_URL is not configured')
    return ''
  }
  return url
}
